import axiosInstance from "../../axios/axiosTokenMiddleware";
import { baseUrl, version, mode, role, bulk_deals } from "../../config/config";

const URL = `${baseUrl}${version}${mode}${role}${bulk_deals}`;

export const bulkDealDownloadFile = async (url) => {
  try {
    const response = await axiosInstance.get(url, {
      responseType: "arraybuffer",
    });

    return response.data;
  } catch (error) {
    console.error("Error downloading the file:", error);
    throw error;
  }
};

export const bulkDealDownloadRequest = async ({ category, requestId }) => {
  try {
    const downloadUrl = `${URL}${category}/download_file?request_id=${requestId}`;
   
    console.log("URL:", downloadUrl);
    const fileData = await bulkDealDownloadFile(downloadUrl);

    return fileData;
  } catch (error) {
    console.error("Error during download request:", error);
    throw error;
  }
};
